import React, { useEffect, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress } from "@mui/material";
import { freightBrokerService } from "../../utils/services/freightBrokerService";
import FreightBrokerModal from "../../components/freightBrokerModal";
import FreightBrokerList from "../../components/frieghtBrokerList";

const FreightBroker = () => {
  const [selectedFreightBroker, setSelectedFreightBroker] = useState(null);
  const [freightBrokerList, setFreightBrokerCList] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const fetchFreightBroker = async () => {
    setLoading(true);
    try {
      const skip = page * rowsPerPage;
      const response = await freightBrokerService.fetch(
        rowsPerPage,
        skip,
        searchValue,
      );
      setFreightBrokerCList(response.data);
      setLoading(false);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchFreightBroker();
  }, [page, rowsPerPage, searchValue]);

  return (
    <DashboardContainer
      hideUploadButton={true}
      hideFilterClient={true}
      header={"Freight Broker List"}
      title={"+ Add Freight Broker"}
      setViewMode={setViewMode}
      onSearchData={(x) => {
        if (x.trim()) {
          setSearchValue(x);
          setPage(0);
        } else {
          setSearchValue("");
        }
      }}
      onClickAddButton={() => setOpenModal(true)}
    >
      <FreightBrokerModal
        selectedFreightBroker={selectedFreightBroker}
        handleClose={() => {
          setOpenModal(false);
          setSelectedFreightBroker(null);
        }}
        open={openModal}
        onAddData={fetchFreightBroker}
      />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <>
          <FreightBrokerList
            dataCount={dataCount}
            page={page}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchFreightBroker}
            onEditData={(e) => {
              setSelectedFreightBroker(e);
              setOpenModal(true);
            }}
            data={freightBrokerList}
            viewMode={viewMode}
            selectedFreightBroker={selectedFreightBroker}
            setSelectedFreightBroker={setSelectedFreightBroker}
          />
        </>
      )}
    </DashboardContainer>
  );
};

export default FreightBroker;
